export const yuleArticles = [
  {
    id: "yule-1",
    title: "某选秀节目剪辑争议升级，制作方首次回应排名操控质疑",
    summary: "一段被反复讨论的剪辑，让节目排名成为焦点。制作方的回应能否打消观众疑虑？",
    categoryId: "yule",
    categoryName: "娱乐内幕",
    publishedAt: "2026-10-12 21:30",
    source: "文娱前线",
    tags: ["综艺", "剪辑", "排名争议"],
    heat: 9450,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20stylized%20television%20studio%20stage%20with%20warm%20spotlights%20and%20deep%20slate%20blue%20backdrop%2C%20minimal%20geometric%20illustration%2C%20cinematic%20editorial%20style%2C%20soft%20gradient%20background&width=1200&height=800&seq=focus-yule-01&orientation=landscape",
    content: [
      "一档热度颇高的选秀节目近期陷入剪辑争议。有观众指出，同一段表演在预告与正片中的镜头顺序存在差异，从而怀疑节目组在引导叙事走向。",
      "## 争议从何而来",
      "被讨论最多的，是一段约十秒的镜头。观众比对多个平台版本后发现，画面拼接顺序并不完全一致。相关话题迅速登上讨论榜，并衍生出关于排名的种种猜测。",
      "制作方随后发布说明，称剪辑调整是为了控制时长与节奏，不存在操控排名的安排。但部分观众认为，说明并未回应最核心的疑问。",
      "## 综艺叙事的边界",
      "有从业者表示，综艺节目通过剪辑强化叙事是行业惯例，但如何把握“表达”与“误导”的边界，越来越成为公众关注的议题。",
      "本文为演示示例内容，人物、机构与数据均为虚构，仅用于展示页面排版与交互效果。",
    ],
  },
  {
    id: "yule-2",
    title: "知名乐队解散风波背后：版权分成纠纷浮出水面",
    summary: "一支成立十余年的乐队突然宣布暂停活动，成员之间的分歧或许比对外声明更复杂。",
    categoryId: "yule",
    categoryName: "娱乐内幕",
    publishedAt: "2026-10-11 13:15",
    source: "音乐观察",
    tags: ["音乐", "版权", "分成"],
    heat: 7980,
    content: [
      "一支成立十余年的乐队日前发布声明，宣布暂停所有公开活动。声明措辞克制，但熟悉乐队的人士透露，成员间围绕作品版权与收益分配的分歧已持续一段时间。",
      "## 分成比例的分歧",
      "按照行业惯例，乐队作品的词曲版权与录音版权归属往往由成员协商确定。随着部分歌曲被广泛使用，分成比例的现实差异开始显现。",
      "有音乐版权律师解释，早期约定的条款若不够清晰，随着作品升值和商业使用增多，矛盾容易被放大。",
      "## 解散之外的思考",
      "多位乐迷在社交平台留言，希望乐队成员能妥善处理分歧。业内人士则提醒，乐队应在创作初期就明确权利归属，避免日后纠纷。",
      "本文为演示示例内容，人物、机构与数据均为虚构，仅用于展示页面排版与交互效果。",
    ],
  },
  {
    id: "yule-3",
    title: "影视剧组超期拍摄乱象调查：演员档期与安全谁在买单",
    summary: "为了赶进度而不断压缩周期，超期拍摄背后是成本、档期与安全的连锁反应。",
    categoryId: "yule",
    categoryName: "娱乐内幕",
    publishedAt: "2026-10-10 18:40",
    source: "影视工业观察",
    tags: ["影视制作", "超期", "安全"],
    heat: 6320,
    content: [
      "近期，多部影视项目被曝出拍摄周期大幅超出原计划。超期不仅推高成本，也让演员档期与剧组安全面临连锁压力。",
      "## 超期是如何发生的",
      "受访的剧组工作人员表示，超期往往由多个因素叠加造成：剧本反复调整、天气影响、场地协调困难，以及前期筹备不足。为赶回进度，连续拍摄便成为常态。",
      "有制片人坦言，压缩周期看似节省成本，实则会在后期特效与安全投入上“还回来”。",
      "## 工业化需要尊重规律",
      "业内人士呼吁，影视制作应建立更科学的排期与预算机制，把安全与创作质量放在进度之前。",
      "本文为演示示例内容，人物、机构与数据均为虚构，仅用于展示页面排版与交互效果。",
    ],
  },
  {
    id: "yule-4",
    title: "网络大电影票房注水疑云：凌晨场次为何场场售罄",
    summary: "凌晨三点的场次显示满座，这样的数据真的合理吗？我们拆解了票房背后的几处异常。",
    categoryId: "yule",
    categoryName: "娱乐内幕",
    publishedAt: "2026-10-09 22:05",
    source: "数据观影室",
    tags: ["票房", "数据异常", "网大"],
    heat: 5870,
    content: [
      "某部网络大电影上线后，票房数据一路走高，但有细心的观众发现，其凌晨场次的售票情况异常一致，几乎场场售罄。",
      "## 数据里的几处矛盾",
      "记者比对了多个票务平台的公开数据，发现该片的场次分布与上座率走势存在多处不符合常规的巧合，例如同一时段多个影厅同时满座。",
      "数据分析人士指出，个别异常可能是排片策略所致，但当异常集中出现时，就值得进一步核查。",
      "## 数据透明才能赢得信任",
      "受访观众表示，比起漂亮的数字，他们更希望看到真实、可核验的市场表现。",
      "本文为演示示例内容，人物、机构与数据均为虚构，仅用于展示页面排版与交互效果。",
    ],
  },
  {
    id: "yule-5",
    title: "演唱会黄牛票源头追踪：内部渠道究竟如何流出",
    summary: "一级票务显示售罄，二级市场却现货充足。我们沿着票源线索做了梳理。",
    categoryId: "yule",
    categoryName: "娱乐内幕",
    publishedAt: "2026-10-08 15:20",
    source: "演出市场观察",
    tags: ["演出", "黄牛", "票务"],
    heat: 6740,
    content: [
      "热门演唱会开票即售罄已成常态，与此同时，二级市场上却常能看到大量加价票源。购票难与买票贵，成为观众共同的心结。",
      "## 票源流出的几种可能",
      "业内人士分析，流入二级市场的票源可能来自多个渠道，包括批量采购、渠道预留以及技术手段抢票。不同来源的合法性差异很大。",
      "有法律人士表示，若存在技术性抢票或内部违规转售，可能触及相关管理规定。",
      "## 让购票更公平",
      "多位观众建议，主办方应推广实名制购票与入场核验，压缩加价转售的空间。",
      "本文为演示示例内容，人物、机构与数据均为虚构，仅用于展示页面排版与交互效果。",
    ],
  },
  {
    id: "yule-6",
    title: "某综艺常驻嘉宾突然退出，知情人士透露合约条款分歧",
    summary: "节目录制中途，一位常驻嘉宾突然退出，背后的合约分歧引发外界关注。",
    categoryId: "yule",
    categoryName: "娱乐内幕",
    publishedAt: "2026-10-07 12:00",
    source: "综艺内参",
    tags: ["综艺", "合约", "嘉宾"],
    heat: 4980,
    content: [
      "一档热门综艺录制过半时，一位常驻嘉宾突然宣布退出。消息公布后，关于退出原因的猜测层出不穷。",
      "## 合约条款的分歧",
      "知情人士透露，争议主要集中在节目内容呈现与个人形象授权两项条款上。双方在沟通中未能达成一致。",
      "有经纪行业人士表示，综艺合约往往涉及大量细节，若前期约定不充分，随着节目变化容易产生摩擦。",
      "## 契约精神需要双向尊重",
      "业内人士指出，无论节目组还是艺人，都应在合作初期就把关键条款说清楚，减少后续的不确定性。",
      "本文为演示示例内容，人物、机构与数据均为虚构，仅用于展示页面排版与交互效果。",
    ],
  },
];